import { resetCart } from "../store/slices/cartSlice";
import { setToken, setUserInfo } from "../store/slices/userSlice";
import { setSelectedProduct } from "../store/slices/productsSlice";

/**
 * Resets all Redux slices to their initial state
 * Use this when logging out or deleting account
 */
export const resetReduxStore = (dispatch) => {
  // Reset cart
  dispatch(resetCart());

  // Reset user
  dispatch(setToken(""));
  dispatch(setUserInfo({}));

  // Reset products
  dispatch(setSelectedProduct({}));
};

/**
 * Clears user-specific localStorage data
 * Keeps only the specified keys
 */
export const clearUserStorage = (userId = "guest") => {
  const storageKey = `reduxState_${userId}`;
  localStorage.removeItem(storageKey);
};
